<template>
	<div class="admin">
		<h1>{{getAppName()}}</h1>

		<md-bottom-bar>
			<md-bottom-bar-item md-icon="announcement" :md-active="ifRoute('admin-notifications')" v-on:click.native="goToRoute('admin-notifications')">Értesítések</md-bottom-bar-item>
			<md-bottom-bar-item md-icon="speaker_notes" :md-active="ifRoute('admin-answers')" v-on:click.native="goToRoute('admin-answers')">Válaszok</md-bottom-bar-item>
			<md-bottom-bar-item md-icon="event" :md-active="ifRoute('admin-presentations')" v-on:click.native="goToRoute('admin-presentations')">Napirend</md-bottom-bar-item>
			<md-bottom-bar-item md-icon="face" :md-active="ifRoute('admin-lecturers')" v-on:click.native="goToRoute('admin-lecturers')">Előadók</md-bottom-bar-item>			
			<md-bottom-bar-item md-icon="info_outline" :md-active="ifRoute('admin-information')" v-on:click.native="goToRoute('admin-information')">Információk</md-bottom-bar-item>
			<md-bottom-bar-item md-icon="cancel"  v-on:click.native="logout()">Kijelentkezés</md-bottom-bar-item>
		</md-bottom-bar>

		<router-view></router-view>
	</div>
</template>

<script>
	import * as firebase from "firebase";

	export default {
		methods: {
			ifRoute: function(name){
				return name === this.$route.name;
			},
			goToRoute: function(name){
				this.$router.replace({name: name});
			},
			logout: function(){
				firebase.auth().signOut().then(() => {
					this.$router.push('/');
				}, function(error) {
					console.log(error);
				});
			},
			getAppName(){
				return firebase.apps[0].options.appName;
			}
		},
		created () {
		}
	}
</script>

<style scoped>
	h1{
		color: white;
	}
	.admin {
		text-align: left;
		margin: 16px;
	}
	.admin{
		max-width: 1024px;
		width: 100%;
		display: inline-block;
	}
</style>

<style>
	.head{
		margin: 16px 0;
	}
</style>


// WEBPACK FOOTER //
// AdminView.vue?717c4124